<template>
  <span class="bg-charcoal-50 dark:bg-dark-700 relative overflow-hidden inline-block align-middle rounded-md leading-none pointer-events-none">
    <span class="opacity-0">
      <slot v-if="$slots.default" />
      <template v-else>Hello</template>
    </span>

    <span class="bg-gradient-to-r absolute w-[200%] h-full skeleton" :class="[ getColors() ]" v-if="isAnimated" />
  </span>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  size?: string
  color?: string
  isAnimated?: boolean
}>(), {
  size: '',
  color: 'gray',
  isAnimated: false
})

const getColors = () => {
  if (props.color == 'cobra') return 'from-cobra-500/0 via-cobra-500/5 to-cobra-500/0'
  if (props.color == 'tiger') return 'from-tiger-300/0 via-tiger-300/5 to-tiger-300/0'

  return 'from-whale-300/0 via-whale-100/50 to-whale-300/0'
}

</script>